export default {
  app: {
    env: 'development'
  },
  service: {
    // apiUrl: 'http://localhost:4005' // localal
    // apiUrl: 'https://sea-lion-app-wk7zk.ondigitalocean.app/' // pruebas test
    // apiUrl: 'https://plankton-app-q99sy.ondigitalocean.app/', // produccion inbropi
    apiUrl: 'https://hammerhead-app-4z2gv.ondigitalocean.app/' // produccion redrogo
  },
  reCAPTCHA: {
    siteKey: '6Lcis64ZAAAAAChnc2HZH9p9rMetaN3-P1odMjH6'
  }
}
